import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import { RegionSelection, RegionSelectionService } from 'src/app/region-selection.service';
import { DashboardSummaryService } from 'src/app/dashboard-summary.service';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f4f6f8;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

.live-dot {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #10b981;
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.55);
  animation: live-pulse 1.8s infinite;
}

.refresh-icon {
  display: inline-block;
  font-size: 16px;
  line-height: 1;
}

.refresh-icon.is-spinning {
  animation: spin 0.8s linear infinite;
}

.skeleton {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 37%, #f1f5f9 63%);
  background-size: 400% 100%;
  animation: skeleton 1.4s ease infinite;
}

.lq-track {
  position: relative;
  height: 14px;
  overflow: hidden;
  border-radius: 9999px;
  background: #f1f5f9;
}

.lq-baseline {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #64748b;
}

.lq-bar {
  position: relative;
  z-index: 1;
  min-width: 3px;
  height: 100%;
  border-radius: 9999px;
  transition: width 320ms ease;
}

.lq-plot {
  position: relative;
  height: 360px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: #f8fafc;
  background-image: linear-gradient(#e2e8f0 1px, transparent 1px), linear-gradient(90deg, #e2e8f0 1px, transparent 1px);
  background-size: 10% 10%;
}

.lq-axis {
  position: absolute;
  z-index: 1;
  background: #64748b;
}

.lq-axis--vertical {
  top: 0;
  bottom: 0;
  width: 1px;
}

.lq-axis--horizontal {
  left: 0;
  right: 0;
  height: 1px;
}

.lq-point {
  position: absolute;
  z-index: 3;
  transform: translate(-50%, 50%);
  transition: left 320ms ease, bottom 320ms ease;
}

.lq-point__dot {
  display: block;
  width: 12px;
  height: 12px;
  border: 2px solid #fff;
  border-radius: 9999px;
  box-shadow: 0 0 0 4px var(--tw-ring-color);
}

.lq-point__label {
  position: absolute;
  left: 10px;
  top: -5px;
  width: max-content;
  max-width: 145px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.92);
  padding: 2px 5px;
  color: #334155;
  font-size: 9px;
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

@keyframes live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.55);
  }
  70% {
    box-shadow: 0 0 0 7px rgba(16, 185, 129, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes skeleton {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@media (max-width: 640px) {
  .lq-plot {
    height: 300px;
  }
  .lq-point__label {
    display: none;
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public dataset: any = {
        meta: null,
        regions: [],
        industries: [],
        sources: [],
        methodology: null,
        region_tree: { meta: null, regions: [] }
    };
    public selectedRegion: string = 'daejeon';
    public regionSelectionNotice: string = '';
    public selectedMetric: string = 'worker_lq';
    public selectedIndustryCode: string = '';
    public lqDetailExpanded: boolean = false;
    public detailTableExpanded: boolean = false;
    public loading: boolean = true;
    public refreshing: boolean = false;
    public errorMessage: string = '';
    public nextRefreshIn: number = 30;

    private refreshTimer: any = null;
    private countdownTimer: any = null;
    private readonly selectionSubscription: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( RegionSelectionService)         public regionSelection: RegionSelectionService,@Inject( DashboardSummaryService)         public dashboardSummary: DashboardSummaryService,    ) {
        this.selectionSubscription = this.regionSelection.selection$.subscribe(selection => {
            void this.applySharedSelection(selection);
        });
    }

    public async ngOnInit() {
        await this.service.init();
        void this.dashboardSummary.load();
        const requestedTab = new URLSearchParams(window.location.search).get('tab');
        if (requestedTab === 'representative') {
            window.location.replace('/specialization-distribution');
            return;
        }
        if (requestedTab === 'simulator') {
            window.location.replace('/policy-simulator');
            return;
        }
        await this.regionSelection.loadTree();
        await this.loadAnalysis();
        this.startAutoRefresh();
    }

    public ngOnDestroy() {
        this.clearTimers();
        this.selectionSubscription.unsubscribe();
    }

    public async loadAnalysis() {
        if (this.refreshing) return;

        this.refreshing = true;
        if (!this.dataset.meta) this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('analysis', {
                reference_year: this.regionSelection.referenceYear,
            });
            if (code !== 200 || !data) {
                throw new Error(data?.message || '분석 데이터를 불러오지 못했습니다.');
            }

            this.dataset = data;
            if (!this.regionSelection.selection) this.regionSelection.selectByRef(this.selectedRegion);
            await this.applySharedSelection(this.regionSelection.selection);
            this.nextRefreshIn = this.dataset.meta.refresh_seconds || 30;
        } catch (error) {
            this.errorMessage = error?.message || '데이터 갱신 중 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            this.refreshing = false;
            await this.service.render();
        }
    }

    private startAutoRefresh() {
        this.clearTimers();
        const refreshSeconds = this.dataset?.meta?.refresh_seconds || 30;
        this.nextRefreshIn = refreshSeconds;

        this.refreshTimer = window.setInterval(async () => {
            await Promise.all([
                this.loadAnalysis(),
                this.dashboardSummary.load(true),
            ]);
        }, refreshSeconds * 1000);

        this.countdownTimer = window.setInterval(async () => {
            this.nextRefreshIn = this.nextRefreshIn > 1 ? this.nextRefreshIn - 1 : refreshSeconds;
            await this.service.render();
        }, 1000);
    }

    private clearTimers() {
        if (this.refreshTimer) window.clearInterval(this.refreshTimer);
        if (this.countdownTimer) window.clearInterval(this.countdownTimer);
        this.refreshTimer = null;
        this.countdownTimer = null;
    }

    public async refresh() {
        await Promise.all([
            this.loadAnalysis(),
            this.dashboardSummary.load(true),
        ]);
        this.startAutoRefresh();
    }

    public async selectRegion(region: any) {
        if (region.status !== 'ready') return;
        this.regionSelection.selectByRef(region.key);
        await this.applySharedSelection(this.regionSelection.selection);
    }

    public async onRegionSelected(selection: RegionSelection) {
        await this.applySharedSelection(selection);
    }

    public async selectRegionByKey(regionKey: string) {
        const region = this.dataset.regions.find((item: any) => item.key === regionKey);
        if (!region || region.status !== 'ready') return;
        await this.selectRegion(region);
    }

    public get selectedRegionSelection() {
        return this.regionSelection.selection;
    }

    public get blockedRegionAttempt() {
        return this.regionSelection.blockedAttempt;
    }

    public get dashboardRegionSummary() {
        const selection = this.selectedRegionSelection;
        if (!selection) return null;
        if (!this.activeRegion) {
            return {
                analysis_ready: false,
                notice: this.regionSelectionNotice,
            };
        }
        const topIndustries = this.activeRows
            .filter((row: any) => row.regions[this.selectedRegion]?.signal === '이중 특화')
            .sort((left: any, right: any) => {
                const leftValue = left.regions[this.selectedRegion].establishment_lq
                    + left.regions[this.selectedRegion].worker_lq;
                const rightValue = right.regions[this.selectedRegion].establishment_lq
                    + right.regions[this.selectedRegion].worker_lq;
                return rightValue - leftValue;
            })
            .slice(0, 3)
            .map((row: any) => `${row.code} ${row.short_name}`)
            .join(' · ');
        return {
            analysis_ready: true,
            business_count: this.activeRegion.establishments,
            employment_count: this.activeRegion.workers,
            specialized_count: this.activeRegion.specialized_count,
            industry_count: this.dataset.meta.industry_count,
            top_industries: topIndustries,
        };
    }

    public async selectMetric(metric: string) {
        this.selectedMetric = metric;
        await this.service.render();
    }

    public get activeRegion() {
        return this.dataset.regions.find((region: any) => region.key === this.selectedRegion) || null;
    }

    public get activeRows() {
        return this.dataset.industries.filter((row: any) => row.regions?.[this.selectedRegion]);
    }

    public get selectedIndustryRow() {
        return this.activeRows.find((row: any) => row.code === this.selectedIndustryCode)
            || this.activeRows[0]
            || null;
    }

    public get selectedIndustryMetric() {
        return this.selectedIndustryRow?.regions?.[this.selectedRegion] || null;
    }

    public get topSpecializedRows() {
        return [...this.activeRows]
            .sort((left: any, right: any) => {
                const leftMetric = left.regions[this.selectedRegion];
                const rightMetric = right.regions[this.selectedRegion];
                const leftDual = leftMetric.signal === '이중 특화' ? 1 : 0;
                const rightDual = rightMetric.signal === '이중 특화' ? 1 : 0;
                if (leftDual !== rightDual) return rightDual - leftDual;
                return (rightMetric.establishment_lq + rightMetric.worker_lq)
                    - (leftMetric.establishment_lq + leftMetric.worker_lq);
            })
            .slice(0, 3);
    }

    public get chartMax() {
        const values: number[] = [];
        this.activeRows.forEach((row: any) => {
            const current = row.regions[this.selectedRegion];
            values.push(current.establishment_lq || 0, current.worker_lq || 0);
        });
        return Math.max(2, Math.ceil(Math.max(...values, 0)));
    }

    public get baselinePercent() {
        return 100 / this.chartMax;
    }

    public metricValue(row: any) {
        return row.regions?.[this.selectedRegion]?.[this.selectedMetric] || 0;
    }

    public metricLabel() {
        return this.selectedMetric === 'establishment_lq' ? '사업체 LQ' : '종사자 LQ';
    }

    public barWidth(value: number) {
        return Math.min((value / this.chartMax) * 100, 100);
    }

    public plotStyle(row: any) {
        const current = row.regions?.[this.selectedRegion];
        if (!current) return {};
        return {
            left: `${Math.min((current.establishment_lq / this.chartMax) * 100, 98)}%`,
            bottom: `${Math.min((current.worker_lq / this.chartMax) * 100, 98)}%`
        };
    }

    public selectedPointStyle() {
        return this.selectedIndustryRow ? this.plotStyle(this.selectedIndustryRow) : {};
    }

    public async changeSelectedIndustry(event: any) {
        this.selectedIndustryCode = event?.target?.value || '';
        this.lqDetailExpanded = false;
        await this.service.render();
    }

    public async selectIndustryCode(industryCode: string) {
        this.selectedIndustryCode = industryCode;
        this.lqDetailExpanded = false;
        await this.service.render();
    }

    public async toggleLqDetail() {
        this.lqDetailExpanded = !this.lqDetailExpanded;
        await this.service.render();
    }

    public async toggleDetailTable() {
        this.detailTableExpanded = !this.detailTableExpanded;
        await this.service.render();
    }

    public selectedIndustryInterpretation(): string {
        const row = this.selectedIndustryRow;
        const metric = this.selectedIndustryMetric;
        if (!row || !metric) return '선택 산업의 검증된 LQ 데이터를 확인할 수 없습니다.';
        const signal = metric.signal === '이중 특화'
            ? '사업체와 종사자 LQ가 모두 1을 초과하는 이중 특화 신호입니다.'
            : metric.signal === '단일 지표'
                ? '두 LQ 중 하나만 1을 초과하는 단일 특화 신호입니다.'
                : '두 LQ 모두 전국 기준 1 이하입니다.';
        return `${row.code} ${row.short_name}: ${signal}`;
    }

    public formatCount(value: number | null | undefined) {
        if (value === null || value === undefined) return '-';
        return value.toLocaleString('ko-KR');
    }

    public formatLq(value: number) {
        if (value === null || value === undefined) return '-';
        return Number(value).toFixed(2);
    }

    public formatSyncTime(value: string) {
        if (!value) return '-';
        return new Date(value).toLocaleTimeString('ko-KR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    }

    public regionCardClass(region: any) {
        if (region.status !== 'ready') return 'border-dashed border-slate-300 bg-slate-50 text-slate-500';
        if (region.key === this.selectedRegion) {
            const selectedClasses: any = {
                daejeon: 'border-indigo-500 bg-indigo-50 text-indigo-950 ring-2 ring-indigo-100',
                cheonan: 'border-sky-500 bg-sky-50 text-sky-950 ring-2 ring-sky-100',
                asan: 'border-emerald-500 bg-emerald-50 text-emerald-950 ring-2 ring-emerald-100',
                cheongju: 'border-violet-500 bg-violet-50 text-violet-950 ring-2 ring-violet-100'
            };
            return selectedClasses[region.key] || selectedClasses.daejeon;
        }
        return 'border-slate-200 bg-white text-slate-900 hover:border-slate-300';
    }

    public signalClass(signal: string) {
        if (signal === '이중 특화') return 'bg-emerald-100 text-emerald-700';
        if (signal === '단일 지표') return 'bg-amber-100 text-amber-700';
        return 'bg-slate-100 text-slate-600';
    }

    public lqClass(value: number) {
        if (value >= 1.5) return 'text-emerald-700';
        if (value > 1) return 'text-indigo-700';
        return 'text-slate-600';
    }

    public groupClass(group: string) {
        const groups: any = {
            '소재': 'bg-amber-100 text-amber-700',
            '바이오': 'bg-rose-100 text-rose-700',
            '전자': 'bg-sky-100 text-sky-700',
            '정밀의료': 'bg-violet-100 text-violet-700',
            '전기': 'bg-cyan-100 text-cyan-700',
            '기계': 'bg-slate-200 text-slate-700',
            '모빌리티': 'bg-indigo-100 text-indigo-700'
        };
        return groups[group] || 'bg-slate-100 text-slate-600';
    }

    private async applySharedSelection(selection: RegionSelection | null) {
        if (!this.dataset?.meta) return;
        if (!selection) {
            this.selectedRegion = '';
            this.regionSelectionNotice = '지역을 선택하면 산업 분포와 LQ 분석 결과를 확인할 수 있습니다.';
            await this.service.render();
            return;
        }

        const legacyRegion = this.dataset.regions.find((item: any) =>
            item.key === selection.analysis_key && item.status === 'ready'
        );
        if (legacyRegion) {
            this.selectedRegion = legacyRegion.key;
            this.regionSelectionNotice = '';
            this.ensureSelectedIndustry();
        } else {
            this.selectedRegion = '';
            this.regionSelectionNotice = selection.analysis_status === 'READY'
                ? '전국 시도 분석은 아래 전국 특화 분포에서 확인할 수 있습니다. 기존 상세 LQ 카드 연결은 검증된 원자료 범위부터 확장합니다.'
                : '추가 검토 필요: 원자료 적재와 모집단·연도·KSIC·전국 분모 검증 전에는 LQ를 표시하지 않습니다.';
        }
        await this.service.render();
    }

    private ensureSelectedIndustry() {
        const currentExists = this.activeRows.some((row: any) => row.code === this.selectedIndustryCode);
        if (currentExists) return;
        const top = this.topSpecializedRows[0] || this.activeRows[0];
        this.selectedIndustryCode = top?.code || '';
    }
}

export default PageDashboardComponent;